import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import JBImage from 'components/essentials/JBImage';
import Cta from 'components/essentials/Cta/components/Cta';
import ProtectionPlanListItem from './ProtectionPlanListItem';
const ProtectionPlansItem = t0 => {
  const $ = _c(44);
  const {
    ctaButtonChildren,
    ctaId,
    icon,
    image,
    isLoading: t1,
    isMostPopular: t2,
    onClick: t3,
    planDescription,
    planName,
    planPrice,
    showImages: t4
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const isMostPopular = t2 === undefined ? false : t2;
  const onClick = t3 === undefined ? _temp : t3;
  const showImages = t4 === undefined ? false : t4;
  const t5 = !showImages;
  let t6;
  if ($[0] !== showImages || $[1] !== t5) {
    t6 = classNames("relative rounded border-0 group/ProtectionPlansItem flex-1", {
      "mt-0.5 !bg-white": showImages,
      "!bg-gray-light8 md:!bg-white": t5
    });
    $[0] = showImages;
    $[1] = t5;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  const t7 = !isLoading ? onClick : _temp2;
  let t8;
  if ($[3] !== image || $[4] !== showImages) {
    t8 = showImages && !!image && <JBImage alt="" className="rounded-tl rounded-tr h-auto w-full" crop="center" fit="crop" height="157" src={image} width="345" />;
    $[3] = image;
    $[4] = showImages;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  let t9;
  if ($[6] !== isMostPopular || $[7] !== showImages) {
    t9 = isMostPopular && <div className={classNames("text-xs absolute px-2 py-1 rounded-sm bg-[#f3ebd5] font-bold whitespace-nowrap text-center", {
      "top-2 left-2": showImages,
      "left-4 md:left-0 -top-2 md:-top-6": !showImages
    })}>Most Popular</div>;
    $[6] = isMostPopular;
    $[7] = showImages;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  const t10 = !showImages;
  let t11;
  if ($[9] !== t10) {
    t11 = classNames("relative min-h-[15rem] p-4 md:p-6", {
      "rounded-none border border-solid border-gray-light7 h-full bg-white m-4 md:bg-transparent md:m-0": t10
    });
    $[9] = t10;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== planName) {
    t12 = <h2 className="m-0 text-lg font-bold">{planName}</h2>;
    $[11] = planName;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] !== planPrice) {
    t13 = Intl.NumberFormat().format(planPrice);
    $[13] = planPrice;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] !== t13) {
    t14 = <div className="text-lg font-bold text-left">${t13}</div>;
    $[15] = t13;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] !== t12 || $[18] !== t14) {
    t15 = <div className="flex flex-col">{t12}{t14}</div>;
    $[17] = t12;
    $[18] = t14;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== icon) {
    t16 = <div aria-hidden="true">{icon}</div>;
    $[20] = icon;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] !== t15 || $[23] !== t16) {
    t17 = <div className="flex justify-between">{t15}{t16}</div>;
    $[22] = t15;
    $[23] = t16;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== planDescription) {
    t18 = planDescription?.map(_temp3);
    $[25] = planDescription;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] !== t18) {
    t19 = <ul className="mx-0 my-3 min-h-[9rem]">{t18}</ul>;
    $[27] = t18;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  let t20;
  if ($[29] !== ctaButtonChildren || $[30] !== ctaId || $[31] !== isLoading) {
    t20 = <Cta as="span" block={true} className="pointer-events-none border border-solid group-hover/ProtectionPlansItem:border-brand-dark" color="brand-light" data-xc={ctaId} disabled={isLoading} isLoading={isLoading} onClick={_temp4} styling="solid-button">{ctaButtonChildren}</Cta>;
    $[29] = ctaButtonChildren;
    $[30] = ctaId;
    $[31] = isLoading;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  let t21;
  if ($[33] !== t11 || $[34] !== t17 || $[35] !== t19 || $[36] !== t20) {
    t21 = <div className={t11}>{t17}{t19}{t20}</div>;
    $[33] = t11;
    $[34] = t17;
    $[35] = t19;
    $[36] = t20;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] !== t21 || $[39] !== t6 || $[40] !== t7 || $[41] !== t8 || $[42] !== t9) {
    t22 = <button type="button" className={t6} onClick={t7}>{t8}{t9}{t21}</button>;
    $[38] = t21;
    $[39] = t6;
    $[40] = t7;
    $[41] = t8;
    $[42] = t9;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  return t22;
};
ProtectionPlansItem.propTypes = {
  ctaButtonChildren: PropTypes.node,
  ctaId: PropTypes.string,
  icon: PropTypes.node,
  image: PropTypes.string,
  isLoading: PropTypes.bool,
  isMostPopular: PropTypes.bool,
  onClick: PropTypes.func,
  planDescription: PropTypes.arrayOf(PropTypes.string),
  planName: PropTypes.string,
  planPrice: PropTypes.number,
  showImages: PropTypes.bool
};
export default ProtectionPlansItem;
function _temp() {}
function _temp2() {}
function _temp3(desc) {
  return <ProtectionPlanListItem key={desc} desc={desc} />;
}
function _temp4() {}